<template>
    <!-- 物流系统 比价订舱服务商界面 -->
    <div class="container">
        <el-form
                :model="offerPriceData"
                ref="ruleForm"
                :rules="rules"
                label-width="140px"
                class="el_form"
                label-position="top"
                v-loading="loading"
                element-loading-text="加载中···"
        >
            <!-- 基础信息区域 -->
            <el-row :gutter="15">
                <el-col :span="12">
                    <el-form-item label="表单编号" size="small">
                        <el-input v-model="offerPriceData.formid" readonly disabled placeholder="-"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="当前排名" size="small">
                        <el-input
                                v-model="offerPriceData.ranking"
                                readonly
                                disabled
                                placeholder="暂无排名"
                                :style="{color: offerPriceData.ranking ? '#2196F3' : ''}"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="表单状态" size="small">
                        <el-input
                                v-model="offerPriceData.status"
                                readonly
                                disabled
                                placeholder="-"
                                :style="statusStyle(offerPriceData.status)"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 其他基础信息 -->
            <el-row :gutter="15">
                <el-col :span="24">
                    <el-form-item label="备注" size="small">
                        <el-input
                                v-model="offerPriceData.memo"
                                readonly
                                disabled
                                placeholder="-"
                                type="textarea"
                                :rows="2"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 多航班信息区域 -->
            <el-form-item label="航班信息" size="small" class="flight-group">
                <el-table
                        :data="offerPriceData.flightDetailList"
                        border
                        size="small"
                        class="flight-table"
                >
                    <!-- 序号列 -->
                    <el-table-column
                            type="index"
                            label="序号"
                            width="60"
                            align="center"
                    ></el-table-column>

                    <!-- 航班号列 -->
                    <el-table-column
                            prop="flightNumber"
                            label="航班号"
                            align="center"
                            min-width="100"
                    ></el-table-column>

                    <!-- 航班日期列 -->
                    <el-table-column
                            prop="flightDate"
                            label="航班日期"
                            align="center"
                            min-width="140"
                    ></el-table-column>

                    <!-- 起点列 -->
                    <el-table-column
                            prop="origin"
                            label="起点"
                            align="center"
                            min-width="80"
                    ></el-table-column>

                    <!-- 目的地点列 -->
                    <el-table-column
                            prop="arrival"
                            label="目的地"
                            align="center"
                            min-width="80"
                    ></el-table-column>

                    <!-- 金额输入列 -->
                    <el-table-column
                            label="报价金额"
                            align="center"
                            min-width="160"
                    >
                        <template slot-scope="scope">
                            <el-input
                                    v-model.number="scope.row.price"
                                    type="number"
                                    placeholder="请输入金额"
                                    :disabled="issubmitDisabled"
                                    clearable
                                    size="small"
                                    @input="handlePriceChange(scope.row)"
                            ></el-input>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 总价显示 -->
                <div class="total-price">
                    <span class="label">总价：</span>
                    <span class="value">{{ totalPriceDisplay }}</span>
                    <span class="label"> ￥/人</span>
                </div>

                <!-- 无航班信息提示 -->
                <div
                        v-if="!offerPriceData.flightDetailList || offerPriceData.flightDetailList.length === 0"
                        class="no-flight"
                >
                    <el-empty description="暂无航班信息"></el-empty>
                </div>
            </el-form-item>

            <!-- 商家备注（可编辑） -->
            <el-form-item
                    label="商家备注"
                    prop="currentOffermemo"
                    :rules="[
                        { required: false },
                        { type: 'string', max: 500, message: '备注不能超过500个字符', trigger: 'blur' }
                    ]"
            >
                <el-input
                        v-model="currentOffermemo"
                        type="textarea"
                        :rows="5"
                        :disabled="issubmitDisabled"
                        clearable
                        placeholder="请输入商家备注信息（最多500字）"
                ></el-input>
            </el-form-item>

            <!-- 历史商家备注（只读） -->
            <el-form-item
                    label="最近一次商家备注"
                    v-if="showHistoryMemo"
            >
                <el-input
                        v-model="historyOffermemo"
                        type="textarea"
                        :rows="5"
                        disabled
                        clearable
                        placeholder="暂无历史备注"
                ></el-input>
                <p class="history-memo-time" v-if="historyMemoTime">
                    上次编辑时间：{{ historyMemoTime }}
                </p>
            </el-form-item>
        </el-form>

        <!-- 历史报价记录区域 -->
        <el-card
                v-if="historyTableData.length > 0"
                class="history-card"
        >
            <div slot="header">
                <strong>历史报价记录</strong>
                <span style="margin-left: 10px; color: #666; font-size: 12px">
                    共 {{ historyTableData.length }} 条记录
                </span>
            </div>
            <el-table
                    :data="historyTableData"
                    border
                    style="width: 100%"
                    class="historyTableStyle"
                    size="small"
            >
                <el-table-column type="index" width="60" align="center"></el-table-column>
                <el-table-column
                        prop="pircelist"
                        label="报价"
                        align="center"
                        :formatter="formatTotalprice"
                ></el-table-column>
                <el-table-column
                        prop="totalprice"
                        label="总金额"
                        align="center"
                        :formatter="formatPrice"
                ></el-table-column>
                <!--                <el-table-column
                                        prop="offermemo"
                                        label="商家备注"
                                        align="center"
                                        :formatter="offermemo"
                                ></el-table-column>-->
                <el-table-column
                        prop="createtime"
                        label="提交时间"
                        align="center"
                        :formatter="formatTime"
                ></el-table-column>
                <el-table-column
                        label="操作"
                        width="120"
                        align="center"
                        v-if="!issubmitDisabled"
                >
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)"
                                :loading="scope.row.loading"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 无历史记录提示 -->
        <div
                v-else-if="!loading && historyTableData.length === 0"
                class="no-history"
        >
            <el-empty description="暂无报价历史记录"></el-empty>
        </div>

        <!-- 底部提交按钮 -->
        <div class="footer">
            <el-button
                    round
                    class="footer-btn"
                    type="primary"
                    @click="onSubmit"
                    :disabled="issubmitDisabled || loading"
                    :loading="submitLoading"
            >
                {{ issubmitDisabled ? '已提交' : '提交报价' }}
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                offerPriceData: {
                    flightDetailList: []
                },
                // 当前编辑的商家备注
                currentOffermemo: '',
                // 历史商家备注
                historyOffermemo: '',
                // 历史备注的时间
                historyMemoTime: '',
                // 是否显示历史备注区域
                showHistoryMemo: false,
                rules: {
                    price: [
                        { required: true, message: '请输入报价金额', trigger: 'blur' },
                        { type: 'number', min: 0, message: '报价金额必须大于等于0', trigger: 'blur' }
                    ]
                },
                historyTableData: [],
                url: {
                    queryFormFormId: '/airplane/queryById',
                    saveForm: '/airplane/saveOfferPrice',
                    queryHistoryForm: '/airplane/getHistoryLog',
                    deleQuotation: '/airplane/delePrice',
                },
                issubmitDisabled: false,
                loading: true,
                submitLoading: false,
            }
        },
        computed: {
            totalprice() {
                if (!this.offerPriceData.flightDetailList || this.offerPriceData.flightDetailList.length === 0) {
                    return 0;
                }
                return this.offerPriceData.flightDetailList.reduce((sum, flight) => {
                    return sum + (flight.price || 0);
                }, 0);
            },
            totalPriceDisplay() {
                return this.totalprice ? `¥ ${this.totalprice.toFixed(2)}` : '¥ 0.00';
            }
        },
        created() {
            this.initData();
        },
        beforeRouteLeave(to, from, next) {
            if (process.env.NODE_ENV === 'production') {
                localStorage.removeItem('X-Access-Token');
            }
            next();
        },
        methods: {
            initData() {
                this.$get(this.url.queryFormFormId, this.$route.query)
                    .then(res => {
                        if (res.code === 200) {
                            this.offerPriceData = {
                                ...res.result,
                                flightDetailList: (res.result.flightDetailList || []).map(flight => ({
                                    ...flight,
                                    price: null
                                }))
                            };

                            if (this.offerPriceData.hasOffered) {
                                this.issubmitDisabled = true;
                            }

                            this.queryHistoryForm_API();
                        } else {
                            this.$message.error(res.message || '获取数据失败');
                            if ([401, 403].includes(res.code)) {
                                this.handleTokenExpired();
                            }
                        }
                    })
                    .catch(err => {
                        console.error('初始化数据失败:', err);
                        this.$message.error('页面超时：即将跳转到登录页重新获取登录信息');
                        this.handleTokenExpired();
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            handleTokenExpired() {
                localStorage.removeItem('X-Access-Token');
                const currentPath = encodeURIComponent(window.location.href);
                setTimeout(() => {
                    window.location.href = `${window.location.protocol}//${window.location.host}/login?redirect=${currentPath}`;
                }, 2000);
            },

            handlePriceChange(flight) {
                if (flight.price !== null && flight.price !== undefined) {
                    flight.price = Number(flight.price.toFixed(2));
                }
            },

            onSubmit() {
                this.$refs.ruleForm.validate((valid) => {
                    if (!valid) {
                        this.$message.warning('请完善报价信息后再提交');
                        return;
                    }

                    const hasEmptyPrice = this.offerPriceData.flightDetailList.some(flight =>
                        flight.price === null || flight.price === undefined || flight.price < 0
                    );

                    if (hasEmptyPrice) {
                        this.$message.warning('报价金额有误，数值必须大于或等于0');
                        return;
                    }

                    if (this.totalprice <= 0) {
                        this.$message.warning('总价金额必须大于0');
                        return;
                    }

                    this.submitLoading = true;

                    const pircelist = this.offerPriceData.flightDetailList
                        .map(flight => `${flight.origin}-${flight.arrival}：${flight.price}`)
                        .join('；');

                    const payload = {
                        formid: this.offerPriceData.formid,
                        id: this.offerPriceData.id,
                        status: this.offerPriceData.status,
                        totalprice: this.totalprice,
                        offermemo: this.currentOffermemo, // 提交当前编辑的备注
                        pircelist: pircelist
                    };

                    this.$post(this.url.saveForm, payload)
                        .then(res => {
                            if (res.code === 200) {
                                this.$message.success('提交成功，排名已更新');
                                this.issubmitDisabled = true;

                                if (res.result?.rank !== undefined) {
                                    this.offerPriceData.ranking = res.result.rank;
                                }

                                // 重新加载历史记录，更新历史备注
                                this.queryHistoryForm_API();
                            } else {
                                this.$message.error(res.message || '提交失败，请重试');
                                if ([401, 403].includes(res.code)) {
                                    this.handleTokenExpired();
                                }
                            }
                        })
                        .catch(err => {
                            console.error('提交报价失败:', err);
                            this.$message.error('网络错误，提交失败');
                            this.handleTokenExpired();
                        })
                        .finally(() => {
                            this.submitLoading = false;
                        });
                });
            },

            handleDelete(index, row) {
                this.$confirm('确定要删除这条报价记录吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$set(this.historyTableData[index], 'loading', true);

                    this.$get(this.url.deleQuotation, {
                        id: this.offerPriceData.id,
                        status: this.offerPriceData.status,
                        createtime: row.createtime
                    })
                        .then(res => {
                            if (res.code === 200) {
                                this.$message.success('删除成功');
                                this.queryHistoryForm_API();
                            } else {
                                this.$message.error(res.message || '删除失败');
                                if ([401, 403].includes(res.code)) {
                                    this.handleTokenExpired();
                                }
                            }
                        })
                        .catch(err => {
                            this.$message.error('网络错误，删除失败');
                            console.error('删除报价失败:', err);
                            this.handleTokenExpired();
                        })
                        .finally(() => {
                            this.$set(this.historyTableData[index], 'loading', false);
                        });
                }).catch(() => {
                    this.$message.info('已取消删除');
                });
            },

            queryHistoryForm_API() {
                if (!this.offerPriceData.id) return;

                this.$get(this.url.queryHistoryForm, {
                    id: this.offerPriceData.id
                })
                    .then(res => {
                        if (res.code === 200) {
                            this.historyTableData = res.result || [];

                            // 处理历史备注信息
                            if (this.historyTableData.length > 0) {
                                // 取最新的一条历史记录的备注作为上次备注
                                const latestHistory = this.historyTableData[this.historyTableData.length - 1];
                                this.historyOffermemo = latestHistory.offermemo || '';
                                this.historyMemoTime = latestHistory.createtime ? this.formatTime(latestHistory.createtime) : '';

                                // 如果有历史备注且与当前备注不同，则显示历史备注区域
                                this.showHistoryMemo = this.historyOffermemo.trim() !== '';

                                // 未提交状态下，将当前备注初始化为最新历史备注
                                if (!this.issubmitDisabled) {
                                    this.currentOffermemo = latestHistory.offermemo || '';
                                }
                            } else {
                                // 无历史记录时的处理
                                this.showHistoryMemo = false;
                                this.historyOffermemo = '';
                                this.historyMemoTime = '';

                                // 未提交状态且无历史记录，当前备注清空
                                if (!this.issubmitDisabled) {
                                    this.currentOffermemo = '';
                                }
                            }
                        } else {
                            this.$message.error(res.message || '获取历史记录失败');
                            if ([401, 403].includes(res.code)) {
                                this.handleTokenExpired();
                            }
                        }
                    })
                    .catch(err => {
                        console.error('获取历史报价失败:', err);
                        this.historyTableData = [];
                        this.handleTokenExpired();
                    });
            },

            formatTotalprice(row) {
                return row.pircelist;
            },

            formatPrice(row) {
                return row.totalprice ? '¥ ' + row.totalprice.toFixed(2) : '-';
            },

            formatTime(row) {
                if (!row.createtime) return '-';
                // 假设时间格式为ISO字符串，可根据实际格式调整
                const date = new Date(row.createtime);
                return date.toLocaleString('zh-CN', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                }).replace(/\//g, '-');
            },

            statusStyle(status) {
                const styleMap = {
                    '待报价': { color: '#FF9800' },
                    '已截止': { color: '#F44336' },
                    '已完成': { color: '#4CAF50' },
                    '报价中': { color: '#2196F3' }
                };
                return styleMap[status] || {};
            }
        }
    }
</script>

<style lang="less" scoped>
    .flight-table {
        width: 100%;
        margin-bottom: 15px;

        /deep/ .el-table__header-wrapper th {
            background-color: #f5f7fa;
        }

        /deep/ .el-table__body-wrapper .el-table__row:hover {
            background-color: #f9fafc;
        }

        /deep/ .el-input__inner {
            text-align: right;
            width: 120px;
        }
    }

    .container {
        padding: 15px;
        padding-bottom: 80px;
    }

    .el_form {
        padding: 10px 10px 20px;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);

        /deep/ .el-form-item__label {
            padding: 0 0 5px 0;
            font-weight: 500;
        }
        /deep/ .el-form-item {
            margin-bottom: 15px;
        }
    }

    .flight-group {
        /deep/ .el-form-item__content {
            padding-left: 15px;
        }
    }

    .flight-card {
        margin-bottom: 15px;
        /deep/ .el-card__header {
            padding: 10px 15px;
            border-bottom: 1px solid #eee;
        }
    }

    .no-flight {
        padding: 20px;
        text-align: center;
    }

    .history-card {
        margin: 15px 0;
        background: #fff;
    }

    .historyTableStyle {
        margin-top: 10px;
        /deep/ .el-table__row:hover {
            background-color: #f5f7fa;
        }
    }

    .no-history {
        margin: 20px 0;
        padding: 30px;
        background: #fff;
        border-radius: 4px;
        text-align: center;
    }

    .footer {
        width: 100%;
        height: 60px;
        line-height: 60px;
        padding: 0 15px;
        background: #fff;
        border-top: 1px solid #eee;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
        box-sizing: border-box;

        .footer-btn {
            width: 100%;
            height: 40px;
            line-height: 40px;
        }
    }

    /* 历史备注样式 */
    .history-memo-time {
        margin-top: 8px;
        color: #666;
        font-size: 12px;
        text-align: right;
        margin-bottom: 0;
    }

    @media screen and (max-width: 768px) {
        .el_form {
            padding: 10px 5px;
        }

        .footer {
            height: 50px;
            line-height: 50px;
        }

        .footer-btn {
            height: 36px;
            line-height: 36px;
        }

        .flight-card {
            margin-bottom: 10px;
        }
    }
</style>